import React, { useState, useEffect } from "react";
import ImageWithBasePath from '../imageWithBasePath'
import { Link, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux";
import { setDataTheme } from "../../redux/themeSettingSlice";
import { all_routes } from "../../../feature-module/router/all_routes";
import LoginModal from "../modal/loginModal";
import RegisterModal from "../modal/registerModal";
import ForgotPasswordModal from "../modal/forgotPassword";
import ChangePasswordModal from "../modal/changePassword";
import CompanyRegisterModal from "../modal/CompanyRegisterModal";
import { useAuth } from "../../../feature-module/auth/AuthProvider";
import LanguageDropdown from "./components/LanguageDropdown";
import { t } from "../../../lang/index";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isResponsive, setIsResponsive] = useState(false);
  const [isOffcanva, setIsOffcanva] = useState(false);
  const [isMegaMenu, setIsMegaMenu] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const dataTheme = useSelector((state: any) => state.themeSetting.dataTheme);
  const handleDataThemeChange = (theme: string) => {
    dispatch(setDataTheme(theme));
  };
  const openSubMenu = () => {
    setIsDropdownOpen(!isDropdownOpen);
    setOpenDropdownIndex(null);
  };
  const routes = all_routes
  const toggleSubMenu = (index: any) => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
    setIsDropdownOpen(false);
  };

  const sideBar = [
    {
      tittle: t("header.sidebar.tuktuk.title"),
      base: "tuk tuk",
      subTitle: t("header.sidebar.tuktuk.subtitle"),
      showAsTab: false,
      separateRoute: false,
      twoTitle: false,
      img: "assets/img/menu/tuk-tuk.png",
      menu: [
        {
          menuValue: t("header.sidebar.tuktuk.menu.grid"),
          route: "/flight/flight-grid",
          hasSubRoute: false,
          showSubRoute: false,
          base: "flight-grid",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
      ],
    },
    {
      tittle: t("header.sidebar.about.title"),
      base: "about",
      subTitle: t("header.sidebar.about.subtitle"),
      showAsTab: false,
      separateRoute: false,
      twoTitle: true,
      img: "assets/img/menu/flight.jpg",
      menu: [
        {
          menuValue: t("header.sidebar.about.menu.aboutUs"),
          route: routes.about_us,
          hasSubRoute: false,
          showSubRoute: false,
          base: "about",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
        {
          menuValue: t("header.sidebar.about.menu.testimonials"),
          route: routes.Testimonials,
          hasSubRoute: false,
          showSubRoute: false,
          base: "testimonials",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
        {
          menuValue: t("header.sidebar.about.menu.faq"),
          route: routes.FAQ,
          hasSubRoute: false,
          showSubRoute: false,
          base: "faq",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
        {
          menuValue: t("header.sidebar.about.menu.contact"),
          route: routes.contactUs,
          hasSubRoute: false,
          showSubRoute: false,
          base: "contact-us",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
        {
          menuValue2: t("header.sidebar.about.menu.terms"),
          route: routes.termsConditions,
          hasSubRoute: false,
          showSubRoute: false,
          base: "terms-conditions",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
        {
          menuValue2: t("header.sidebar.about.menu.privacy"),
          route: routes.privacyPolicy,
          hasSubRoute: false,
          showSubRoute: false,
          base: "privacy-policy",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
      ],
    },
    {
      tittle: t("header.sidebar.dashboard.title"),
      base: "dashboard",
      subTitle: t("header.sidebar.dashboard.subtitle"),
      subTitle2: t("header.sidebar.dashboard.subtitle2"),
      showAsTab: false,
      separateRoute: false,
      twoTitle: true,
      img: "assets/img/menu/flight.jpg",
      menu: [
        {
          menuValue: t("header.sidebar.dashboard.menu.dashboard"),
          route: routes.userDashboard,
          hasSubRoute: false,
          showSubRoute: false,
          base: "user-dashboard",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
        {
          menuValue: t("header.sidebar.dashboard.menu.myBookings"),
          route: routes.userTukTukBooking,
          hasSubRoute: false,
          showSubRoute: false,
          base: "my-bookings",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
        {
          menuValue: t("header.sidebar.dashboard.menu.reviews"),
          route: routes.userReviews,
          hasSubRoute: false,
          showSubRoute: false,
          base: "reviews",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
        {
          menuValue: t("header.sidebar.dashboard.menu.support"),
          route: routes.userSupport,
          hasSubRoute: false,
          showSubRoute: false,
          base: "message",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
        {
          menuValue: t("header.sidebar.dashboard.menu.wishlist"),
          route: routes.userWishlist,
          hasSubRoute: false,
          showSubRoute: false,
          base: "wishlist",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
        {
          menuValue: t("header.sidebar.dashboard.menu.wallet"),
          route: routes.userWallet,
          hasSubRoute: false,
          showSubRoute: false,
          base: "wallet",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
        {
          menuValue: t("header.sidebar.dashboard.menu.profileSettings"),
          route: routes.userProfileSettings,
          hasSubRoute: false,
          showSubRoute: false,
          base: "profile-settings",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
        {
          menuValue: t("header.sidebar.dashboard.menu.notifications"),
          route: routes.notification,
          hasSubRoute: false,
          showSubRoute: false,
          base: "notifications",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
        {
          menuValue: t("header.sidebar.dashboard.menu.myProfile"),
          route: routes.myProfile,
          hasSubRoute: false,
          showSubRoute: false,
          base: "my-profile",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
        {
          menuValue: t("header.sidebar.dashboard.menu.settings"),
          route: routes.profileSettings,
          hasSubRoute: false,
          showSubRoute: false,
          base: "settings",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
        {
          menuValue2: t("header.sidebar.dashboard.menu.dashboard2"),
          route: routes.agentDashboard,
          hasSubRoute: false,
          showSubRoute: false,
          base: "admin-dashboard",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
        {
          menuValue2: t("header.sidebar.dashboard.menu.bookings"),
          route: routes.agentHotelBooking,
          hasSubRoute: false,
          showSubRoute: false,
          base: "bookings",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
        {
          menuValue2: t("header.sidebar.dashboard.menu.enquiries"),
          route: routes.agentEnquirers,
          hasSubRoute: false,
          showSubRoute: false,
          base: "enquiries",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
        {
          menuValue2: t("header.sidebar.dashboard.menu.earnings"),
          route: routes.agentEarnings,
          hasSubRoute: false,
          showSubRoute: false,
          base: "earnings",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
        {
          menuValue2: t("header.sidebar.dashboard.menu.reviews2"),
          route: routes.agentReview,
          hasSubRoute: false,
          showSubRoute: false,
          base: "reviews",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
        {
          menuValue2: t("header.sidebar.dashboard.menu.settings2"),
          route: routes.agentSettings,
          hasSubRoute: false,
          showSubRoute: false,
          base: "settings",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
      ],
    },
    {
      tittle: t("header.sidebar.social.title"),
      base: "social",
      subTitle: t("header.sidebar.social.subtitle"),
      showAsTab: false,
      separateRoute: false,
      twoTitle: false,
      img: "assets/img/menu/feed-de-atividade.png",
      menu: [
        {
          menuValue: t("header.sidebar.social.menu.feed"),
          route: "/user/feed",
          hasSubRoute: false,
          showSubRoute: false,
          base: "feed",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
        {
          menuValue: t("header.sidebar.social.menu.myProfilePage"),
          route: "/user/feed/minhas-postagens",
          hasSubRoute: false,
          showSubRoute: false,
          base: "My Profile page",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
        {
          menuValue: t("header.sidebar.social.menu.explore"),
          route: "/user/feed/explore",
          hasSubRoute: false,
          showSubRoute: false,
          base: "Explore",
          page: "",
          last: "",
          subMenus: [],
          icon: "",
        },
      ],
    },

  ];
  const BASE_URL = process.env.REACT_APP_API_URL;
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 991) {
        setIsResponsive(true);
      } else {
        setIsResponsive(false);
        setIsOffcanva(false)
      }
    };

    // Call the function on mount
    handleResize();

    // Attach resize listener
    window.addEventListener('resize', handleResize);

    // Cleanup listener on unmount

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    // Add event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    document.documentElement.setAttribute("class", dataTheme);
  }, [dataTheme])

  const { isLoggedIn, isAgent, isDriver, user } = useAuth();


  const [isAdmin, setIsAdmin] = useState(false);

  // Verifica se o usuário é admin
  useEffect(() => {
    if (!isLoggedIn) return;

    const token = localStorage.getItem("token");
    if (!token) return;

    fetch(`${BASE_URL}/usuarios/me/is-admin`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Erro ao verificar admin");
        return res.json();
      })
      .then((data) => setIsAdmin(data))
      .catch(() => setIsAdmin(false));
  }, [isLoggedIn, BASE_URL]);

  const DarkButton = () => {
    return (
      <div className="me-3">
        <Link
          to="#"
          id="dark-mode-toggle"
          className={`theme-toggle ${dataTheme === 'light' && 'activate'}`}
          onClick={() => handleDataThemeChange("dark-mode")}
        >
          <i className="isax isax-moon" />
        </Link>
        <Link
          to="#"
          id="light-mode-toggle"
          className={`theme-toggle ${dataTheme === 'dark-mode' && 'activate'}`}
          onClick={() => handleDataThemeChange("light")}
        >
          <i className="isax isax-sun-1" />
        </Link>
      </div>
    )
  }
  return (
    <>
      <div className={`main-header ${location.pathname === '/index-2' || location.pathname === '/index-4' || location.pathname === '/index-6' ? 'main-header-four' : ''} `}>
        {/* Header Topbar*/}
        {location.pathname === '/index-2' || location.pathname === '/index-3' || location.pathname === '/index-4'
          || location.pathname === '/index-5' || location.pathname === '/index-6' ?
          <></> :
          <div className="header-topbar text-center bg-transparent">
            <div className="container">
              <div className="d-flex align-items-center justify-content-between flex-wrap">
                <p className="d-flex align-items-center fw-medium fs-14 mb-2">
                  <i className="isax isax-call5 me-2" />
                  {t("header.telefone")} : +1 56565 56594
                </p>
                <div className="d-flex align-items-center">
                  <p className="mb-2 me-3 d-flex align-items-center fw-medium fs-14">
                    <i className="isax isax-message-text-15 me-2" />
                    Email : portugaltourway@gmail.com
                  </p>
                  <LanguageDropdown />
                </div>
              </div>
            </div>
          </div>
        }

        {/* /Header Topbar*/}
        {/* Header */}
        <header className={`${scrolled ? "fixed" : ""} ${location.pathname === '/index-2' && 'header-four'} ${location.pathname === '/index-3' && 'header-three'} ${location.pathname === '/index-4' && 'header-four'} ${location.pathname === '/index-5' && 'header-five'} ${location.pathname === '/index-6' && 'header-six'}`}>
          <div className="container">
            <div className={`offcanvas-info ${isOffcanva ? 'show' : ''}`}>
              <div className="offcanvas-wrap">
                <div className="offcanvas-detail">
                  <div className="offcanvas-head">
                    <div className="d-flex justify-content-between align-items-center mb-3">

                      <Link to={routes.home1} className="black-logo-responsive">
                        <ImageWithBasePath src="assets/img/logo-dark.svg" alt="logo-img" />
                      </Link>
                      <Link to={routes.home1} className="white-logo-responsive">
                        <ImageWithBasePath src="assets/img/logo.svg" alt="logo-img" />
                      </Link>
                      <div className="offcanvas-close" onClick={() => setIsOffcanva(false)}>
                        <i className="ti ti-x" />
                      </div>
                    </div>
                  </div>

                  {/*MENU LATERAL MOBILE*/}
                  <div className={`mobile-menu fix mb-3 ${isResponsive ? 'mean-container' : ''}`} >
                    <div className="mean-bar">
                      <nav className="mean-nav">
                        <ul className="main-nav" style={{ display: "none" }}>
                          {sideBar.map((mainMenus, i) => (
                            <React.Fragment key={i}>
                              {mainMenus.separateRoute ? (
                                <li
                                  className={`has-submenu megamenu active ${isDropdownOpen ? 'dropdown-opened' : ''
                                    }`}
                                >
                                  <Link to="#">
                                    {mainMenus.tittle}
                                    <i className="fa-solid fa-plus"></i>
                                  </Link>
                                  <ul
                                    className="submenu mega-submenu"
                                    style={{ display: isDropdownOpen ? 'block' : 'none' }}
                                  >
                                    <li>
                                      <div className="megamenu-wrapper">
                                        <div className="d-none d-lg-flex align-items-center justify-content-between flex-wrap">
                                          <h6 className="mb-3">Home Pages</h6>
                                          <Link
                                            to="#"
                                            className="btn btn-dark btn-md mb-3 text-white d-inline-block w-auto"
                                          >
                                            Purchase Template
                                          </Link>
                                        </div>
                                        <div className="row g-lg-4">
                                          {mainMenus.menu.map((menu: any, index: any) => (
                                            <div className="col-lg-2" key={index}>
                                              <div
                                                className={`single-demo ${menu.base === mainMenus.base ? 'active' : ''
                                                  }`}
                                              >
                                                <div className="demo-img">
                                                  <Link to={menu.route}>
                                                    <ImageWithBasePath
                                                      src={menu.img}
                                                      className="img-fluid"
                                                      alt="img"
                                                    />
                                                  </Link>
                                                </div>
                                                <div className="demo-info">
                                                  <Link to={menu.route}>{menu.homeName}</Link>
                                                </div>
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    </li>
                                  </ul>
                                  <Link
                                    className={`mean-expand ${isDropdownOpen ? 'mean-clicked' : ''
                                      }`}
                                    to="#"
                                    style={{ fontSize: '18px' }}
                                    onClick={openSubMenu}
                                  >
                                    <i className="ti ti-plus"></i>
                                  </Link>
                                </li>
                              ) : (
                                <li
                                  className={`has-submenu mega-innermenu ${openDropdownIndex === i ? 'dropdown-opened' : ''
                                    }`}
                                >
                                  <Link to="#">
                                    {mainMenus.tittle}
                                    <i className="fa-solid fa-plus"></i>
                                  </Link>
                                  <ul
                                    className="submenu mega-submenu"
                                    style={{
                                      display: openDropdownIndex === i ? 'block' : 'none',
                                    }}
                                  >
                                    <li>
                                      <div className="megamenu-wrapper">
                                        <div className="row">
                                          <div className="col-lg-6">
                                            <h6>{mainMenus.tittle}</h6>
                                            <ul>
                                              {mainMenus.menu.map((menu: any, index: any) => (
                                                <React.Fragment key={index}>
                                                  {!mainMenus.twoTitle && (
                                                    <li>
                                                      <Link to={routes.flightGrid}>
                                                        {menu.menuValue}
                                                      </Link>
                                                    </li>
                                                  )}
                                                  {mainMenus.twoTitle && menu.menuValue && (
                                                    <li>
                                                      <Link to={routes.flightGrid}>
                                                        {menu.menuValue}
                                                      </Link>
                                                    </li>
                                                  )}
                                                  {mainMenus.twoTitle && menu.menuValue2 && (
                                                    <li>
                                                      <Link to={routes.flightGrid}>
                                                        {menu.menuValue2}
                                                      </Link>
                                                    </li>
                                                  )}
                                                </React.Fragment>
                                              ))}
                                            </ul>
                                            <Link
                                              className="mean-expand"
                                              to="#"
                                              style={{ fontSize: '18px' }}
                                            >
                                              <i className="ti ti-plus"></i>
                                            </Link>
                                          </div>
                                          <div className="col-lg-6">
                                            <div className="menu-img">
                                              <ImageWithBasePath
                                                src={mainMenus?.img || ''}
                                                alt="img"
                                                className="img-fluid"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </li>
                                  </ul>
                                  <Link
                                    className={`mean-expand ${openDropdownIndex === i ? 'mean-clicked' : ''
                                      }`}
                                    to="#"
                                    style={{ fontSize: '18px' }}
                                    onClick={() => toggleSubMenu(i)}
                                  >
                                    <i className="ti ti-plus"></i>
                                  </Link>
                                </li>
                              )}
                            </React.Fragment>
                          ))}
                        </ul>
                      </nav>
                    </div>
                  </div>
                  {/* */}

                  <div className="offcanvas__contact">
                    <div className="mt-4">
                      {/* Seletor de idioma */}
                      <div className="header-dropdown d-flex flex-fill">
                        <div className="w-100">
                          <LanguageDropdown isMobile />
                        </div>
                      </div>

                      {/* Botões dinâmicos */}
                      {isLoggedIn ? (
                        <div className="text-center">
                          <Link
                            to={
                              isAdmin
                                ? all_routes.adminPanel
                                : isAgent
                                  ? routes.agentDashboard
                                  : isDriver
                                    ? routes.driverDashboard
                                    : routes.userDashboard
                            }
                            className="d-flex align-items-center justify-content-center mb-3 text-decoration-none"
                          >
                            <span className="avatar avatar-md">
                              {user?.foto?.id ? (
                                <img
                                  src={`${BASE_URL}/uploads/${user?.foto?.id}`}
                                  alt="Foto de perfil"
                                  className="img-fluid rounded-circle"
                                  style={{
                                    objectFit: "cover",
                                    width: "48px",
                                    height: "48px",
                                    border: "2px solid #fff",
                                  }}
                                />
                              ) : (
                                <ImageWithBasePath
                                  src="assets/img/users/user-05.jpg"
                                  alt="Perfil"
                                  className="img-fluid rounded-circle border border-white border-3"
                                />
                              )}
                            </span>
                            <span className="ms-2 text-white fw-semibold">
                              {user?.nome || "Meu Perfil"}
                            </span>
                          </Link>
                        </div>
                      ) : (
                        <>
                          <div>
                            <Link
                              to="#"
                              className="text-white btn btn-dark w-100 mb-3"
                              data-bs-toggle="modal"
                              data-bs-target="#register-modal"
                            >
                              {t("header.signIn")}
                            </Link>
                          </div>
                          <button
                            className="btn btn-primary w-100"
                            data-bs-toggle="modal"
                            data-bs-target="#company-register-modal"
                          >
                            {t("header.becomeExpert")}
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={`offcanvas-overlay ${isOffcanva ? 'overlay-open' : ''}`} onClick={() => setIsOffcanva(false)} />
            <div className="header-nav">
              <div className="main-menu-wrapper">
                <div className="navbar-logo">
                  <Link className="logo-white header-logo" to={routes.home1}>
                    {location.pathname === '/index-2' || location.pathname === '/index-3' || location.pathname === '/index-4'
                      || location.pathname === '/index-5' ?
                      <ImageWithBasePath src="assets/img/logo-dark.svg" className="logo" alt="Logo" /> :
                      <ImageWithBasePath src="assets/img/logo.svg" className="logo" alt="Logo" />
                    }
                  </Link>
                  {location.pathname !== routes.home6 &&
                    <Link className="logo-dark header-logo" to={routes.home1}>
                      {location.pathname === '/index-2' || location.pathname === '/index-3' || location.pathname === '/index-4'
                        || location.pathname === '/index-5' ?
                        <ImageWithBasePath src="assets/img/logo.svg" className="logo" alt="Logo" /> :
                        <ImageWithBasePath src="assets/img/logo-dark.svg" className="logo" alt="Logo" />
                      }
                    </Link>
                  }
                </div>
                <nav id="mobile-menu">
                  <ul className={`main-nav ${isMegaMenu ? 'active' : ''}`}>
                    {sideBar.map((mainMenus: any, index) => (
                      <React.Fragment key={index}>
                        {mainMenus.twoTitle ? (
                          <li className={`has-submenu mega-innermenu ${mainMenus?.menu?.some((item: any) => item?.route?.includes(location.pathname)) ? "active" : ""}`}>
                            <Link to="#">
                              {mainMenus.tittle}
                              <i className={`${location.pathname === '/index' ? 'fa-solid fa-plus' : 'fa-solid fa-angle-down'} `}></i>
                            </Link>
                            <ul className="submenu mega-submenu">
                              <li>
                                <div className="megamenu-wrapper">
                                  <div className="row g-lg-4">
                                    {/* Sempre mostra menu de usuário comum */}
                                    <div className="col-lg-6">
                                      <h6>{mainMenus.subTitle}</h6>
                                      <ul>
                                        {mainMenus.menu
                                          .filter((menu: any) => !!menu.menuValue)
                                          .map((menu: any, idx: number) => (
                                            <li key={idx} className={location.pathname === menu.route ? 'active' : ''}>
                                              <Link to={menu.route}>{menu.menuValue}</Link>
                                            </li>
                                          ))}
                                      </ul>
                                    </div>

                                    {/* Se for agente, mostra o menu extra */}
                                    {isAgent && (
                                      <div className="col-lg-6">
                                        <h6>{mainMenus.subTitle2}</h6>
                                        <ul>
                                          {mainMenus.menu
                                            .filter((menu: any) => !!menu.menuValue2)
                                            .map((menu: any, idx: number) => (
                                              <li key={idx} className={location.pathname === menu.route ? 'active' : ''}>
                                                <Link to={menu.route}>{menu.menuValue2}</Link>
                                              </li>
                                            ))}
                                        </ul>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </li>
                        ) : (
                          <>
                            {mainMenus.twoTitle ? (
                              <li className={`has-submenu mega-innermenu ${mainMenus?.menu?.some((item: any) => item?.route?.includes(location.pathname)) ? "active" : ""}`}>
                                <Link to="#">
                                  {mainMenus.tittle}
                                  <i className={`${location.pathname === '/index' ? 'fa-solid fa-plus' : 'fa-solid fa-angle-down'} `}></i>
                                </Link>
                                <ul className="submenu mega-submenu">
                                  <li>
                                    <div className="megamenu-wrapper">
                                      <div className="row g-lg-4">
                                        <div className="col-lg-6">
                                          <h6>{mainMenus.subTitle}</h6>
                                          <ul>
                                            {mainMenus.menu.map((menu: { menuValue: any, route: string; }, idx: React.Key | null | undefined) => (
                                              menu.menuValue &&
                                              <li key={idx} className={location.pathname === menu.route ? 'active' : ''}>
                                                <Link to={menu.route}>{menu.menuValue}</Link>
                                              </li>
                                            ))}
                                          </ul>
                                        </div>
                                        <div className="col-lg-6">
                                          <h6>{mainMenus.subTitle2}</h6>
                                          <ul>
                                            {mainMenus.menu.map((menu: { menuValue2: any, route: string; }, idx: React.Key | null | undefined) => (
                                              menu.menuValue2 &&
                                              <li key={idx} className={location.pathname === menu.route ? 'active' : ''}>
                                                <Link to={menu.route}>{menu.menuValue2}</Link>
                                              </li>
                                            ))}
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </li>
                            ) : (
                              <li className={`has-submenu mega-innermenu ${mainMenus?.menu?.some((item: any) => item?.route?.includes(location.pathname)) ? "active" : ""}`}>
                                <Link to="#">
                                  {mainMenus.tittle}
                                  <i className={`${location.pathname === '/index' ? 'fa-solid fa-plus' : 'fa-solid fa-angle-down'} `}></i>
                                </Link>
                                <ul className="submenu mega-submenu">
                                  <li>
                                    <div className="megamenu-wrapper">
                                      <div className="row">
                                        <div className="col-lg-6">
                                          <h6>{mainMenus.subTitle}</h6>
                                          <ul>
                                            {mainMenus.menu.map((menu: { menuValue: string, route: string; }, idx: React.Key | null | undefined) => (
                                              <li key={idx} className={location.pathname === menu.route ? 'active' : ''}>
                                                <Link to={menu.route}>{menu.menuValue}</Link>
                                              </li>
                                            ))}
                                          </ul>
                                        </div>
                                        <div className="col-lg-6">
                                          <div className="menu-img">
                                            <ImageWithBasePath
                                              src={mainMenus.img}
                                              className="img-fluid"
                                              alt="img"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </li>
                            )}
                          </>
                        )}
                      </React.Fragment>
                    ))}
                  </ul>
                </nav>
                <div className="header-btn d-flex align-items-center">
                  <DarkButton />
                  {isLoggedIn ? (
                    <>
                      <Link
                        to={
                          isAdmin
                            ? all_routes.adminPanel
                            : isAgent
                              ? routes.agentDashboard
                              : isDriver
                                ? routes.driverDashboard
                                : routes.userDashboard
                        }
                        className="d-flex align-items-center p-0 me-3 border-0 bg-transparent"
                        style={{ textDecoration: "none" }}
                      >
                        <span className="avatar avatar-md" role="button">
                          {user?.foto?.id ? (
                            <img
                              src={`${BASE_URL}/uploads/${user?.foto?.id}`}
                              alt="Foto de perfil"
                              className="img-fluid rounded-circle"
                              style={{ objectFit: "cover", width: "48px", height: "35px" }}
                            />
                          ) : (
                            <ImageWithBasePath
                              src="assets/img/users/user-05.jpg"
                              alt="Perfil"
                              className="img-fluid rounded-circle border border-white border-4"
                            />
                          )}
                        </span>
                      </Link>
                    </>
                  ) : (
                    <>
                      <div>
                        <Link
                          to="#"
                          className="btn btn-white me-3"
                          data-bs-toggle="modal"
                          data-bs-target="#register-modal"
                        >
                          {t("header.signIn")}
                        </Link>
                      </div>
                      <button className="btn btn-primary me-0" data-bs-toggle="modal" data-bs-target="#company-register-modal">
                        {t("header.becomeExpert")}
                      </button>
                    </>
                  )}
                  <div className="header__hamburger d-xl-none my-auto" onClick={() => setIsOffcanva(true)}>
                    <div className="sidebar-menu">
                      <i className="isax isax-menu5" />
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </header>
        {/* /Header */}
      </div>
      <LoginModal />
      <RegisterModal />
      <CompanyRegisterModal />
      <ForgotPasswordModal />
      <ChangePasswordModal />
    </>


  )
}

export default Header